import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SimplePaginationModel } from 'src/app/models/pagination.model';

@Component({
  selector: 'app-simple-pagination',
  templateUrl: './simple-pagination.component.html',
  styleUrls: ['./simple-pagination.component.scss']
})
export class SimplePaginationComponent {
  @Input() elements: SimplePaginationModel = new SimplePaginationModel(0, 6, 0, 0, 0);
  @Input() sizes: number[] = [5, 10, 25, 50, 100];
  @Input() id: string = "pagination";
  @Output() changed = new EventEmitter<SimplePaginationModel>();

  // Al realizar modificaciones

  constructor() {
  }

  ngOnInit(): void {

  }

  start() {
    this.elements.page = 0;
    this.elements.start = 0;
    this.changed.emit(this.elements);
  }

  last() {
    this.elements.page = Math.ceil(this.elements.total / this.elements.size) - 1;
    this.elements.start = this.elements.page * this.elements.size;
    this.changed.emit(this.elements);
  }

  previous() {
    this.elements.page--;
    this.elements.start = this.elements.page * this.elements.size;
    this.changed.emit(this.elements);
  }

  next() {
    this.elements.page++;
    this.elements.start = this.elements.page * this.elements.size;
    this.changed.emit(this.elements);
  }

  changePageSize() {
    this.elements.start = 0;
    this.elements.page = 0;
    this.changed.emit(this.elements);
  }

  isOnLastPage() {
    return Math.ceil(this.elements.total / this.elements.size) - 1 == this.elements.page;
  }

}
